export default function() {
  document.addEventListener("DOMContentLoaded", () => {
    const numberInput = document.querySelector('#item-qty');
    const requiredInputs = document.querySelectorAll('[data-input-required]');

    if(requiredInputs.length > 0) {
      requiredInputs.forEach(input => {
        input.oninvalid = (e) => {
          e.target.setCustomValidity("");
          if (!e.target.validity.valid) {
              e.target.setCustomValidity(e.target.dataset.inputRequired);
          }
        };
        input.oninput = (e)  =>{
            e.target.setCustomValidity("");
        };
      });
    }

    if(numberInput) {
      let min = numberInput.getAttribute('min');
      let max = numberInput.getAttribute('max');

      numberInput.oninvalid = (e) => {
        e.target.setCustomValidity("");
        if (!e.target.validity.valid) {
            e.target.setCustomValidity(e.target.dataset.errorMsg.replace('{min}', min).replace('{max}', max));
        }
      };
      numberInput.oninput = (e)  =>{
          e.target.setCustomValidity("");
      };
    };

  });
}
